// extracted by mini-css-extract-plugin
export default {"head":"WalletMargin_head__yljh4","body":"WalletMargin_body__Djwkq","button":"WalletMargin_button__dyNk4"};